import { useMemo } from 'react';
import { Select, SelectProps } from '@consta/uikit/Select';
import { Scheme } from '@@/schemes/ts';
import { SCHEMES_INFO_DICTIONARY } from '@@/schemes/dictionaries/schemes.dictionaries';

const items = Object.values(Scheme).map((scheme) => ({
  id: scheme,
  label: SCHEMES_INFO_DICTIONARY[scheme as Scheme]?.name,
  value: scheme,
}));

export function SchemeSelect(props: ISchemeSelectProps) {
  const { label, value, onChange, ...rest } = props;
  const currentValue = useMemo(() => items.find((item) => item.id === value), [value]);
  const onChangeLocal: SelectProps['onChange'] = ({ value }) =>
    onChange(value?.id as Scheme);

  return (
    <Select
      label={label ?? 'Выберите схему'}
      items={items}
      value={currentValue}
      onChange={onChangeLocal}
      {...rest}
    />
  );
}

export interface ISchemeSelectProps
  extends Omit<SelectProps, 'items' | 'groups' | 'value' | 'onChange'> {
  value: Scheme;
  onChange: (scheme: Scheme) => void | Promise<void>;
}
